module.exports = __webpack_public_path__ + "img/forward.fe388ef5.svg";